var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.145,
    height: 29.729,
    viewBox: "0 0 23.145 29.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4aa5ff",
    d: "M427.739-85.44h-23.122c-.021.021 0 3.3 0 3.3v26.429l11.561-4.955 11.561 4.955V-82.14s.03-3.229 0-3.3zm-8.4 19.541l-.277-4.833-.047-.888q-.1.275-.2.558l-1.857 5.106h-1.8l-1.708-5.033-.13-.386c-.013.25-.028.5-.042.747l-.3 4.729h-2.4l.76-10.912h2.584l1.8 5.1c.169.5.316.951.446 1.369.136-.416.29-.869.467-1.369l1.877-5.1h2.588l.68 10.912z",
    transform: "translate(0 0) translate(-404.608 85.44)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM);
export default __webpack_public_path__ + "static/media/M.c0483bd5838e1b2aa28e510c6dc07d6f.svg";
export { ForwardRef as ReactComponent };